export const MOBILE_MIN_WIDTH = 320;
export const MOBILE_MAX_WIDTH = 767;

export const TABLET_MIN_WIDTH = 768;
export const TABLET_MAX_WIDTH = 1023;

export const DESKTOP_MIN_WIDTH = 1024;

export const BREAKPOINTS = {
  MOBILE_MIN_WIDTH,
  MOBILE_MAX_WIDTH,
  TABLET_MIN_WIDTH,
  TABLET_MAX_WIDTH,
  DESKTOP_MIN_WIDTH,
};

/** media features for media queries for vanilla-extract */
export const mq = {
  portrait: '(orientation: portrait)',
  landscape: '(orientation: landscape)',
  maxWidth: (width) => `(max-width: ${width}px)`,
  minWidth: (width) => `(min-width: ${width}px)`,
  minHeight: (height) => `(min-height: ${height}px)`,
  maxHeight: (height) => `(max-height: ${height}px)`,
  supportsHover: '(hover: hover) and (pointer: fine)',
  narrowScreenPortrait: 'screen and (max-aspect-ratio: 1000/1900) and (orientation: portrait)',
};
